import { render, staticRenderFns } from "./EditKnowledgeSettingsSimple.vue?vue&type=template&id=66ab9820"
import script from "./EditKnowledgeSettingsSimple.vue?vue&type=script&lang=js"
export * from "./EditKnowledgeSettingsSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports